<template>
  <div
    role="button"
    class="w-full px-3 py-2 mb-3 duration-200 rounded-lg border grid items-center gap-2 grid-cols-[auto_1fr_auto]"
    :class="{
      'bg-primary/10 text-primary border-primary/40': active,
      'hover:border-primary dark:hover:border-primary bg-surface-0 dark:bg-surface-700 border-transparent':
        !active,
    }"
    @click="emit('setActiveId', item.id)"
  >
    <div class="p-2 bg-primary text-surface-0 rounded-full">
      <AiChatIcon class="h-5 w-5" />
    </div>
    <div class="truncate font-medium text-sm">
      <p class="font-semibold truncate">{{ message }}</p>
      <p v-if="item?.messages[1]" class="truncate opacity-80">{{ response }}</p>
      <span class="text-xs opacity-80">{{ date }}</span>
    </div>
    <i class="pi pi-arrow-right text-sm opacity-80" />
  </div>
</template>

<script setup lang="ts">
import AiChatIcon from "@/components/icons/AiChatIcon.vue";
import type { RecentHeyConversationListItem } from "@/types/v2";

const props = defineProps<{
  item: RecentHeyConversationListItem;
  active?: boolean;
}>();

const emit = defineEmits<{
  (e: "setActiveId", id: string): void;
}>();

const date = useTimeAgo(props.item.modified);

const message = computed(() => {
  const content = props.item?.messages[0]?.content || "";
  return formatV2ResponseMessage(content).result;
});
const response = computed(() => {
  const content = props.item?.messages[1]?.content || "";
  return formatV2ResponseMessage(content).result;
});
</script>
